/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Form, FormGroup, Label, Input, Spinner } from 'reactstrap';

import { Container } from './styles';

function ModuloCard({ handleSubmit, setForm, form, loading, cadastrado }) {
  return (
    <Container>
      <h1>Cadastrar módulo</h1>
      <Form style={{ width: '100%' }} onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="name">Nome </Label>
          <Input
            type="text"
            name="name"
            id="name"
            placeholder="Nome do módulo"
            onChange={(e) => {
              setForm({ ...form, nome: e.target.value });
            }}
            required
          />
        </FormGroup>
        <FormGroup tag="fieldset">
          <Label>Situação cadastral</Label>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                disabled={!!cadastrado}
                name="radio1"
                onChange={() => {
                  setForm({ ...form, situacaoCadastral: 1 });
                }}
              />
              Ativo
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                disabled={!!cadastrado}
                name="radio1"
                onChange={() => {
                  setForm({ ...form, situacaoCadastral: 2 });
                }}
              />
              Inativo
            </Label>
          </FormGroup>
        </FormGroup>

        <FormGroup>
          <Label for="name">Cor </Label>
          <Input
            type="color"
            name="cor"
            id="cor"
            required
            defaultValue="#000000"
            onChange={(e) => {
              setForm({ ...form, cor: e.target.value });
            }}
          />
        </FormGroup>
        <FormGroup>
          <Label for="name">Classe CSS </Label>
          <Input
            type="text"
            name="cor"
            id="cor"
            required
            placeholder="Nome da classe CSS"
            onChange={(e) => {
              setForm({ ...form, classe: e.target.value });
            }}
          />
        </FormGroup>
        <FormGroup>
          <Label for="name">Ordem </Label>
          <Input
            type="number"
            name="ordem"
            id="ordem"
            placeholder="Insira a ordem númerica"
            min={0}
            max={1000}
            onChange={(e) => {
              setForm({ ...form, ordem: e.target.value });
            }}
            required
          />
        </FormGroup>

        {loading ? (
          <Button color="primary" disabled>
            <Spinner size="sm" />
          </Button>
        ) : (
          <Button color="primary" onClick={handleSubmit}>
            Cadastrar
          </Button>
        )}
      </Form>
    </Container>
  );
}

export default ModuloCard;
